export const adModesTR = {
  Tag: {
    default: {
      scripts: ['GPT', 'IdealMedia', 'Prebid', 'Tessera'],
      options: { GPT: { stickyUnits: { mobile: ['masthead'] } } },
    },
    sponsored: {
      scripts: ['GPT'],
      allowedAdUnits: {
        GPT: {
          desktop: ['masthead', 'datacollect'],
          mobile: ['masthead', 'datacollect'],
        },
      },
    },
  },
  Homepage: {
    default: {
      scripts: ['GPT', 'GPTWithoutIframe', 'Adblock', 'Prebid', 'Tessera'],
      options: { GPT: { stickyUnits: { mobile: ['masthead'] } } },
    },
  },
  Category: {
    default: {
      scripts: ['GPT', 'Adblock', 'IdealMedia', 'Prebid', 'Tessera'],
      options: { GPT: { withCriteo: true, stickyUnits: { mobile: ['masthead'] } } },
    },
    sponsored: {
      scripts: ['GPT'],
      allowedAdUnits: {
        GPT: {
          desktop: ['masthead', 'datacollect'],
          mobile: ['masthead', 'datacollect'],
        },
      },
    },
  },
  Article: {
    default: {
      scripts: ['GPT', 'Adblock', 'Taboola', 'HtmlAd', 'FooterAd', 'Outstream', 'Prebid', 'Tessera', 'IdealMedia'],
      clientScripts: ['Teads', 'Membrana'],
      // Sticky Temp Remove
      // options: { GPT: { withCriteo: true, stickyUnits: { desktop: ['masthead'] } } },
      options: { GPT: { withCriteo: true, stickyUnits: { mobile: ['masthead'] } } },
      ignoredAdUnits: {
        GPT: {
          desktop: ['bottomBranding'],
          mobile: ['bottomBranding'],
        },
        Taboola: {
          desktop: ['icerikArasiMiddle1', 'icerikArasiBottom'],
          mobile: ['icerikArasiMiddle1', 'icerikArasiBottom'],
        },
      },
    },
    PremiumUser: {
      scripts: [],
    },
    sponsored: {
      scripts: ['GPT', 'SponsoredArticle'],
      options: { GPT: { withCriteo: true } },
      allowedAdUnits: {
        GPT: {
          desktop: ['masthead', 'datacollect', 'bottomBranding'],
          mobile: ['masthead', 'datacollect', 'icerikArasiMiddle1', 'bottomBranding'],
        },
      },
    },
    onlyCriteo: {
      scripts: ['Taboola', 'Outstream'],
      clientScripts: ['Teads'],
    },
    noAds: {
      scripts: ['Taboola'],
    },
  },
  Webview: {
    default: {
      scripts: ['GPT', 'Taboola'],
      options: { GPT: { withCriteo: true } },
    },
    PremiumUser: {
      scripts: [],
    },
    sponsored: {
      scripts: ['GPT', 'SponsoredArticle'],
      allowedAdUnits: {
        GPT: {
          mobile: ['webviewMasthead', 'datacollect'],
        },
      },
    },
  },
  Custom: {
    onlyGPT: {
      scripts: ['Prebid', 'GPT'],
    },
    Games: {
      scripts: ['GPT', 'Prebid', 'FooterAd', 'Tessera'],
    },
    Astrology: {
      scripts: ['GPT', 'Prebid', 'FooterAd', 'Tessera'],
    },
  },
};
